/**
 * List Schema of Promocao
 * @author Simpli CLI generator
 */
import {
  Helper,
  Schema,
  FieldSet,
  FieldComponent,
  Component,
} from 'simpli-web-sdk'
import {Promocao} from '@/model/resource/Promocao'

/* TODO: review generated schema */
export class ListPromocaoSchema extends Schema {
  readonly name = 'ListPromocao'

  readonly fieldSet: FieldSet<Promocao> = {
    idPromocaoPk: (): FieldComponent => ({
      is: Component.Render,
    }),
    nome: (): FieldComponent => ({
      is: Component.Render,
    }),
    urlImagem: (schema): FieldComponent => ({
      is: Component.RenderImage,
      bind: {
        src: schema.model.urlImagem,
        alt: this.translateFrom(schema.fieldName),
        innerClass: 'w-50 h-50',
      },
    }),
    urlRedirect: (): FieldComponent => ({
      is: Component.Render,
    }),
    dataInicio: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: Helper.datetime(schema.model.dataInicio),
      },
    }),
    dataFim: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: Helper.datetime(schema.model.dataFim),
      },
    }),
    dataCriacao: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: Helper.datetime(schema.model.dataCriacao),
      },
    }),
    ativo: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: Helper.bool(schema.model.ativo),
      },
    }),
  }
}
